<template>
    <div class="p-2 free-gift">
        <div v-if="$root.mobile">
            <div class="gift-filled-bar-wrapper">
                <div class="gift-filled-bar" :style="{ width: percent+'%' }"></div>
            </div>
        </div>
        <div class="pt-2 free-gift-description">
            <span class="mx-4">{{ title }}</span> <img :src="image" :title="title"/>
        </div>
    </div>
</template>
<script>
    import {mapState} from 'vuex';

    export default {
        computed: {
            ...mapState({
                translations: state => state.translations,
                title: state => state.freeGift.title,
                image: state => state.freeGift.image,
                percent: state => state.freeGift.percent,
            }),
        }
    }
</script>
<style scoped lang="scss">
    .free-gift {
        font-size: 18px;
        font-weight: 700;;
        color: #00bdff;

        img {
            height: 83px;
        }

        .gift-filled-bar-wrapper {
            height: 24px;
            background: #ffffff;
            border: 1px solid #000000;
            padding: 1px;

            .gift-filled-bar {
                background-color: #00bdff;
                transition: width 1s ease-in-out;
                height: 100%;
                width: 0;
            }
        }

        .free-gift-description {
            @media (max-width: 1349px) {
                display: flex;
                align-items: center;
                margin: 0 0 15px 0 !important;
                background: #f2f2f2;
                font-size: 16px;
                span {
                    text-align: center;
                    order: 2;
                }
                img {
                    order: 1;
                    margin-right: 10px;
                }
            }
        }
    }
</style>
